// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__CN18V","disabled":"FileBtn_disabled__3izGs","warn":"FileBtn_warn__3Gx4S","fade":"FileBtn_fade__2a-fh"};